import { render, staticRenderFns } from "./AverageHoursInput.vue?vue&type=template&id=e5b89b48&scoped=true&"
import script from "./AverageHoursInput.vue?vue&type=script&lang=ts&"
export * from "./AverageHoursInput.vue?vue&type=script&lang=ts&"
import style0 from "./AverageHoursInput.vue?vue&type=style&index=0&id=e5b89b48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5b89b48",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VRow,VTextField})
